import { render, staticRenderFns } from "./MenuAction.vue?vue&type=template&id=68d12540"
import script from "./MenuAction.vue?vue&type=script&lang=js"
export * from "./MenuAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports